import React from 'react';
import styled from 'styled-components';

type OfferCardProps = {
  menuDisplayName?: string | null;
  menuDisplayImage?: string | null;
};

export const TEST_ID_OFFER_CARD = 'offer-card';

export function OfferCard({ menuDisplayName, menuDisplayImage }: OfferCardProps): JSX.Element {
  return (
    <Container data-testid={TEST_ID_OFFER_CARD}>
      <Content background={menuDisplayImage}>
        <Title>{menuDisplayName}</Title>
        <Button>Shop</Button>
      </Content>
    </Container>
  );
}

const Container = styled.div`
  border-radius: ${({ theme }) => theme.radius.cards};
  height: 155px;
  margin-right: 14px;
  position: relative;
  width: 310px;
`;

const Content = styled.div<{ background?: string | null }>`
  align-items: center;
  background: linear-gradient(180deg, rgba(11, 31, 50, 0.432) 33.75%, rgba(11, 31, 50, 0.9) 100%),
    url(${(props) => (props.background ? props.background : '/images/default-special-card.jpg')});
  background-position: center left;
  background-size: cover;
  border-radius: ${({ theme }) => theme.radius.lg};
  display: grid;
  height: 100%;
  padding: 29px;
`;

const Title = styled.span`
  font-weight: bold;
  font-size: 16px;
  line-height: 1.2;
  color: #ffffff;
  text-shadow: 0px 2px 4px rgb(152 163 173 / 36%);
  width: 100%;
  word-break: break-word;
`;

const Button = styled.button`
  background: transparent;
  border-radius: ${({ theme }) => theme.radius.buttons};
  border: 2px solid #ffffff;
  color: #ffffff;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  height: 32px;
  line-height: 13px;
  text-transform: ${({ theme }) => theme.textTransforms.buttons};
  width: 65px;
`;
